import React from 'react';

import { useOrderProductSuggestions } from '@/hooks/api/order';
import { useTranslation } from 'react-i18next';

import ProductSuggestion from './product-suggestion';

const ProductSuggestions = () => {
    const [t] = useTranslation('order.product-suggestions');
    const suggestions = useOrderProductSuggestions();

    if (suggestions.length === 0) {
        return null;
    }

    return (
        <div className="m2g-order-item m2g-order-product-suggestions">
            <div className="m2g-order-product-suggestions-title m2g-text--offset m2g-text--small">
                {t('add_for_free')}
            </div>
            <div className="m2g-order-product-suggestions-list">
                {suggestions.map((suggestion, i) => (
                    <ProductSuggestion
                        key={i}
                        action={suggestion.action}
                        product={suggestion.product}
                        category={suggestion.category}
                        all_suggestions_count={suggestions.length}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProductSuggestions;
